/// <reference path='../_all.ts' />

module search {
  'use strict';

  /**
   *
   */
  searchKeyword.$inject = ['searchService', '$timeout'];
  export function searchKeyword(searchService : ISearchService, $timeout : ng.ITimeoutService): ng.IDirective {
    return {
      restrict: 'A',
      link: function (scope : ISearchKeywordScope, element: any, attr: ng.IAttributes) {
        searchService.setKeywordInputElement(element);

        // Write data to the model
        var read = () => {
          var keyword :string = element.val();
          searchService.setKeyword(keyword);
        };

        // Listen for change events to enable binding
        element.on('blur keyup change', function() {
          scope.$evalAsync(read);
        });
        read(); // initialize

        searchService.subscribeLoading(scope, (event : ng.IAngularEvent, isLoading : boolean) => {
          if (isLoading) {
            $(element).parent().addClass("loading");      
          } else {
            $(element).parent().removeClass("loading");
          }
        });
         
      }
    }
  }
}